import {
    GET_EXAM_ROOM_ASSIGNMENTS_FAIL,
    GET_EXAM_ROOM_ASSIGNMENTS_SUCCESS,
    ADD_EXAM_ROOM_ASSIGNMENT_SUCCESS,
    ADD_EXAM_ROOM_ASSIGNMENT_FAIL,
    UPDATE_EXAM_ROOM_ASSIGNMENT_SUCCESS,
    UPDATE_EXAM_ROOM_ASSIGNMENT_FAIL,
    DELETE_EXAM_ROOM_ASSIGNMENT_SUCCESS,
    DELETE_EXAM_ROOM_ASSIGNMENT_FAIL,
    RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS,

    GENERATE_EXAM_ROOM_SEATS, 
    GENERATE_EXAM_ROOM_SEATS_SUCCESS, 
    GENERATE_EXAM_ROOM_SEATS_FAIL,

    GET_EXAM_ROOM_SEATS_SUCCESS,
    RESET_EXAM_ROOM_SEATS_SUCCESS,


} from "./actionTypes";

const INIT_STATE = {
    examRoomAssignments: [],
    //assignments:       [],
    seats:             [],
    seatsStats:        null,
    isGenerating:      false,
    error: null,
    loading: true,
    success: false
};

const examRoomAssignmentReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des examRoomAssignments
        case GET_EXAM_ROOM_ASSIGNMENTS_SUCCESS:
            return {
                ...state,
                examRoomAssignments: action.payload, // tableau d'objets examRoom
                loading: false,
                error: null
            };

        case GET_EXAM_ROOM_ASSIGNMENTS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une examRoome
        case ADD_EXAM_ROOM_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                examRoomAssignments: [action.payload, ...state.examRoomAssignments], // ajoute au début du tableau
                error: null,
                success: true
            };

        case ADD_EXAM_ROOM_ASSIGNMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Mise à jour d'une examRoome
        case UPDATE_EXAM_ROOM_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                examRoomAssignments: state.examRoomAssignments.map(examRoom =>
                    examRoom.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet examRoom
                        : examRoom
                ),
                error: null,
                 success: true
            };

        case UPDATE_EXAM_ROOM_ASSIGNMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Suppression d'une examRoome
        case DELETE_EXAM_ROOM_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                examRoomAssignments: state.examRoomAssignments.filter(
                    examRoomAssignment => examRoomAssignment.id !== action.payload
                ),
                error: null
            };


        case DELETE_EXAM_ROOM_ASSIGNMENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS:
                    return { 
                        ...state, 
                        success: false 
                    };

        // ─── Places ───────────────────────────────────────────────────────────
        case GENERATE_EXAM_ROOM_SEATS:
            return { ...state, isGenerating: true };

        case GENERATE_EXAM_ROOM_SEATS_SUCCESS:
            return {
                ...state,
                isGenerating: false,
                seats:        action.payload.seats,
                seatsStats:   action.payload.stats,
            };

        case GENERATE_EXAM_ROOM_SEATS_FAIL:
            return { ...state, isGenerating: false, error: action.payload };

        case GET_EXAM_ROOM_SEATS_SUCCESS:
            return {
                ...state,
                seats:      action.payload.seats,
                seatsStats: action.payload.stats,
            };

        case RESET_EXAM_ROOM_SEATS_SUCCESS:
            return { ...state, seats: [], seatsStats: null };


        default:
            return state;
    }
};

export default examRoomAssignmentReducer;
